import { render, staticRenderFns } from "./WDatePicker.vue?vue&type=template&id=95c87278&"
import script from "./WDatePicker.vue?vue&type=script&lang=js&"
export * from "./WDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports